module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_normal.930c46da.png";